import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/base/component/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/base/component/navbar.tsx");
